import { render, staticRenderFns } from "./DispatchTable.vue?vue&type=template&id=166393ba&scoped=true"
import script from "./DispatchTable.vue?vue&type=script&lang=js"
export * from "./DispatchTable.vue?vue&type=script&lang=js"
import style0 from "./DispatchTable.vue?vue&type=style&index=0&id=166393ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166393ba",
  null
  
)

export default component.exports